import { createContext, useContext } from 'react';

// Create the context
export const MobileContext = createContext<boolean>(false);

// Create a custom hook to use the context
export function useMobile() {
  return useContext(MobileContext);
}
